import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { commonApi } from "../services/commonService";
import alertReducer from "../features/alert/alerts";
import spinnerReducer from "../features/spinner/spinner";
import downloaderReducer from "../features/downloader/downloader";
import rtkQueryErrorLogger from "./errorMiddleware";
import { captchaServiceApi } from "../services/captchaService";
import { objectStoreApi } from "../services/objectStoreServices";
import { loginApi } from "../services/ERO_management/loginservice";
import { nullificationServicesApi } from "../services/nullificationservice";
import { preCoutingServicesApi } from "../services/preCountingServices";
import { announceElectionServiceApi } from "../services/announceElection";
import { reportsServicesApi } from "../services/reportsServices";
import { loginServiceApi } from "../../src/services/loginservices";
// import { userApi } from "../services/api";
import { otpserviceApi } from "../services/User_management/otpService";
import { userServiceApi } from "../services/User_management/userService";
import { epbAndPinService } from "../services/epbAndEpbPinService";
import { newstateApi } from "../services/controltable/ecictservice";
import { finalizeGenerateServiceApi } from "../services/finalizeGenerateViewTransmitService";

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "reduxjs-toolkit-persist";
import storage from "reduxjs-toolkit-persist/lib/storage";
import dragDropReducer from "../features/dragAndDrop/dragAndDrop";
// import { dragDropApi } from "../services/dragDropServices";
import rootReducer from "../features";
import { sendSmsServiceApi } from "../services/sendSmsService";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: {
    login: persistedReducer,
    // [userApi.reducerPath]: userApi.reducer,
    dragDrop: dragDropReducer,
    common: persistedReducer,
    [commonApi.reducerPath]: commonApi.reducer,
    spinner: spinnerReducer,
    downloader:downloaderReducer,
    alert: alertReducer,
    // [dragDropApi.reducerPath]: dragDropApi.reducer,
    [captchaServiceApi.reducerPath]: captchaServiceApi.reducer,
    [objectStoreApi.reducerPath]: objectStoreApi.reducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [userServiceApi.reducerPath]: userServiceApi.reducer,
    [otpserviceApi.reducerPath]: otpserviceApi.reducer,
    [nullificationServicesApi.reducerPath]: nullificationServicesApi.reducer,
    [preCoutingServicesApi.reducerPath]: preCoutingServicesApi.reducer,
    [announceElectionServiceApi.reducerPath]:
      announceElectionServiceApi.reducer,
    [reportsServicesApi.reducerPath]: reportsServicesApi.reducer,
    [loginServiceApi.reducerPath]: loginServiceApi.reducer,
    [finalizeGenerateServiceApi.reducerPath]:
      finalizeGenerateServiceApi.reducer,
    [epbAndPinService.reducerPath]: epbAndPinService.reducer,
    [newstateApi.reducerPath]: newstateApi.reducer,
    [sendSmsServiceApi.reducerPath]:sendSmsServiceApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      // .concat(userApi.middleware)
      .concat(commonApi.middleware)
      .concat(rtkQueryErrorLogger)
      .concat(captchaServiceApi.middleware)
      .concat(objectStoreApi.middleware)
      .concat(loginApi.middleware)
      .concat(userServiceApi.middleware)
      .concat(otpserviceApi.middleware)
      .concat(nullificationServicesApi.middleware)
      .concat(preCoutingServicesApi.middleware)
      .concat(announceElectionServiceApi.middleware)
      .concat(reportsServicesApi.middleware)
      .concat(loginServiceApi.middleware)
      .concat(finalizeGenerateServiceApi.middleware)
      .concat(epbAndPinService.middleware)
      .concat(newstateApi.middleware)
      .concat(sendSmsServiceApi.middleware)
      ,
});
setupListeners(store.dispatch);
